import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let data = {
    加载完成: false,
    当前代理商: null,
    当前公司: null,
    当前门店: null,
    有权限门店list: [],

    门店list: [],
    员工list: [],
    商品list: [],

    通道list: [],

    版本号: "20260501",
    软件名称: "代理商crm系统",
};

export default new Vuex.Store({
    state: JSON.parse(JSON.stringify(data)),
    mutations: {
        init(state) {
            //初始化数据,在注销,重新登录的时候会要初始化数据
            Object.assign(state, JSON.parse(JSON.stringify(data)));
        },
        setobj(state, obj) {
            if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
            if (!(obj.value || obj.v)) state[obj.name || obj.n] = null;
            else state[obj.name || obj.n] = { ...(obj.value || obj.v) };
        },
        setarr(state, obj) {
            if (!obj || !(obj.value || obj.v)) return;
            if (!state[obj.name || obj.n]) state[obj.name || obj.n] = [];
            state[obj.name || obj.n].push(...(obj.value || obj.v));
        },
        setvalue(state, obj) {
            state[obj.name || obj.n] = obj.value || obj.v;
        },
        setobjarr(state, obj) {
            if (!obj || !(obj.value || obj.v)) return;
            if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
            if (!state[obj.name || obj.n][obj.name2 || obj.n2]) Vue.set(state[obj.name || obj.n], obj.name2 || obj.n2, []);
            state[obj.name || obj.n][obj.name2 || obj.n2].push(...(obj.value || obj.v));
        },
        setobjvalue(state, obj) {
            if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
            if (!state[obj.name || obj.n][obj.name2 || obj.n2]) Vue.set(state[obj.name || obj.n], obj.name2 || obj.n2, obj.value || obj.v);
            else state[obj.name || obj.n][obj.name2 || obj.n2] = obj.value || obj.v;
        },
        setobjobj(state, obj) {
            if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
            Vue.set(state[obj.name || obj.n], obj.name2 || obj.n2, obj.value || obj.v);
        },
        cleararr(state, obj) {
            let name = obj.name || obj.n || obj;
            if (!state[name]) state[name] = [];
            state[name].splice(0, state[name].length);
        },
        clearobjarr(state, obj) {
            if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
            state[obj.name || obj.n][obj.name2 || obj.n2].splice(0, state[obj.name || obj.n][obj.name2 || obj.n2].length);
        },
        设置arr顺序(state, { name, where, 顺序key = "I_顺序", oldIndex, newIndex, 排序前where }) {
            let list = state[name] || [];
            if (排序前where) list = list.Where(排序前where);
            let old = list.splice(oldIndex, 1)[0];
            if (old) list.splice(newIndex, 0, old);
            if (where) list = list.Where(where);

            list.forEach((e, index) => {
                e[顺序key] = index;
            });
            list = list.OrderBy((a) => a[顺序key]);
        },
    },
    actions: {
        async 获取员工({ commit, state }) {
            let result = await window.vm.$postAsync("/api/agent", {
                cmd: "员工_list",
                I_公司编号: state.当前公司.I_公司编号,
            });
            commit("cleararr", { name: "员工list" });
            commit("setarr", { name: "员工list", value: result.data });
        },
        async 获取门店({ commit, state }) {
            let result = await window.vm.$postAsync("/api/agent", {
                cmd: "门店_list",
                I_公司编号: state.当前公司.I_公司编号,
            });
            commit("cleararr", { name: "门店list" });
            commit("setarr", { name: "门店list", value: result.data });
        },
        async 获取商品({ commit, state }) {
            let result = await window.vm.$postAsync("/api/agent", {
                cmd: "商品_list",
                I_公司编号: state.当前公司.I_公司编号,
                I_门店编号: state.当前门店.I_门店编号,
            });
            commit("cleararr", { name: "商品list" });
            commit("setarr", { name: "商品list", value: result.data });
        },
        async 获取商户({ commit, state }, data) {
            let result = await window.vm.$postAsync("/api/agent", {
                cmd: "商户_list",
                I_代理Id: state.当前代理商.I_代理Id,
                ...data,
            });
            return result.data;
        },
        async 修改结算日({ commit, state }, data, isShowLoading = true) {
            let result = await window.vm.$postAsync("/api/agent", {
                cmd: "修改结算日",
                ...data,
            }, isShowLoading);
            return result.data;
        },
        async 获取入网支付通道列表({ commit, state }, data) {
            let result = await window.vm.$postAsync("/api/agent", {
                cmd: "获取入网支付通道列表",
                I_代理Id: state.当前代理商.I_代理Id,
            });
            commit("cleararr", { name: "通道list" });
            commit("setarr", { name: "通道list", value: result.data });
            return result.data;
        },
    },
    modules: {},
});
